import React, { useEffect, useRef, useContext, useState } from 'react';
import '../../css/Rent.css';
import { Link } from 'react-router-dom';
import Banner from '../common/Banner';
import Slider from "react-slick";

import forBachelors from '../../images/forBachelors.jpeg';
import greatCommute from '../../images/greatCommute.jpeg';
import ownerFlats from '../../images/ownerFlats.jpeg';
import seller1pic from '../../images/seller1.jpg';
import marker from "../../images/marker.png";
import housingExpert from '../../images/Homepage/expert.png';
import seller2pic from '../../images/seller2.jpg';
import seller3pic from '../../images/seller3.jpg';
import postPropertyBanner from "../../images/Homepage/post-property.png";
import postPropertyBannermob from "../../images/Homepage/post-property-mob.jpg";
import questionMark from "../../images/Homepage/output.gif";
import { useDispatch, useSelector } from 'react-redux';
import { fetchRentAffordableProjects } from '../../redux/homeSlice';
import axios from 'axios';
import { MapContainer, TileLayer, Polygon, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import Testimonial from '../Testimonial';
import AffordableProjects from '../project/AffordableProjects';
import config from '../../config/config';
import { AppContext } from '../../context/AppContext';
import { fetchProfileProperties } from '../../redux/profilePropertySlice';
import AllLocalitiesMap from '../common/AllLocalitiesMap';
import RecommendedSellers from '../RecommendedSellers';
import FeaturedCollection from '../common/FeaturedCollection';
import AdsBannerSection from '../common/AdsBannerSection ';
import ShowcaseAdSection from '../common/ShowcaseAdSection';
const Rents = () => {

  const { user } = useContext(AppContext);

  const dispatch = useDispatch();

  const { rentAffordableProjects, status, error } = useSelector(state => state.home);
  const { properties, status1, error1 } = useSelector((state1) => state1.profileProperty);

  const [wishlist, setWishlist] = useState([]);
  const PrevArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button
        className={`custom-arrow custom-prev`}
        onClick={onClick}
      >
        {"<"}
      </button>
    );
  };

  const NextArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button
        className={`custom-arrow custom-next`}
        onClick={onClick}
      >
        {">"}
      </button>
    );
  };


  useEffect(() => {
    dispatch(fetchRentAffordableProjects());
  }, [dispatch]);

  const sellerRef = useRef(null);
  const sliderRef = useRef(null);


  const handlePrevClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
    if (sellerRef.current) {
      sellerRef.current.slick();
    }
  };

  const handleNextClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
    if (sellerRef.current) {
      sellerRef.current.slickNext();
    }
  };


  // Feature Collection
  const feature = {
    centerMode: true,
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
    ]
  };

  const featurebachelors = {
    backgroundImage: `url(${forBachelors})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  };
  const featurecommute = {
    backgroundImage: `url(${greatCommute})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  };
  const featureflats = {
    backgroundImage: `url(${ownerFlats})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  };

  // seller
  const seller = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
    ]
  };

  // testimonial
  const testimonial = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
    ]
  };

  const [areaCoords, setAreaCoords] = useState(null);
  const [lonLat, setLonLat] = useState([26.9163447327997, 75.7884844894515]);

  const handleLatLon = (lat, lon) => {

    setLonLat([lat, lon]);
    setAreaCoords(null)
  };

  const [allLocalities, setAllLocalities] = useState([]);



  useEffect(() => {

    const fetchAllLocalities = async () => {

      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/search/allLocalities?city_id=${1}&service=${'rent'}&type=${'apartment'}`);
        setAllLocalities(response.data?.data || []); // Update suggestions state

        // console.log(response?.data?.data[0]);

      } catch (error) {
        console.error('Error fetching localities:', error);
      }

    };

    fetchAllLocalities();

  }, []);

  const customIcon = new L.Icon({
    iconUrl: marker, // URL to your custom marker image
    iconSize: [85, 85], // Size of the icon
    iconAnchor: [16, 32], // Anchor position for the icon
    popupAnchor: [0, -32] // Position of the popup relative to the icon
  });
  const handleDispatch = () => {
    if (user?.data?.id != null) {
      dispatch(fetchProfileProperties(user?.data?.id));
    }

  }

  useEffect(() => {

    if (properties?.wishlist) {
      setWishlist(properties.wishlist.map(Number)); // Convert to integers
    }


  }, [properties]);
  useEffect(() => {
    handleDispatch();
  }, [user?.data?.id]);


  return (
    <div>
      {/* Banner */}
      <Banner category='rent' />


      {/* Affordable Projects */}

      <AffordableProjects title={'Explore Our Affordable Projects For Rent'} affordableProjects={rentAffordableProjects} user={user} token={config.getAuthToken()} wishlist={wishlist} handleDispatch={handleDispatch} category='rent' />

      <AdsBannerSection />    

          {/* Recommended Sellers */}
          <RecommendedSellers />

       {/* Top Localities */}
          {allLocalities?.length > 0 && (
         <AllLocalitiesMap allLocalities={allLocalities} category={'rent'} property_type={'apartment'}/>
          )}

          <ShowcaseAdSection />

      <section className="postProperty-section sectiontopgap">
        <Link to="/postProperty">
          <div className="container-fluid p-0">
            <div className='desk'>
              <img src={questionMark} className="banner-mark" />
              <img src={postPropertyBanner} className="banner-image" />
            </div>

            <div className='mob'>
              <img src={postPropertyBannermob} className="banner-image" />
            </div>
          </div>
        </Link>      
      </section>




      {/* Featured Collections */}


    <FeaturedCollection category='rent' />
   
      {/* Testimonials */}
      <Testimonial />

    </div>

  );
};

export default Rents; 